module.exports = __webpack_public_path__ + "files/576089de6d8ed768eb75de75b4838151.png";